<template>
  <Tabs wide :value="valueLocal" :tab-list="tabList" @onSelect="onTabSelect">
    <template v-slot:[tabs.personalAccountTab]="{ active, onSelect }">
      <Tab
        :isDisabled="isDisabled"
        :is-selected="active"
        :title="$t('authentication-app.tab.personal-account.short')"
        icon="user"
        wide
        data-testid="personal-account"
        @click.native="onSelect"
      />
    </template>
    <template v-slot:[tabs.corporateAccountTab]="{ active, onSelect }">
      <Tab
        :isDisabled="isDisabled"
        :is-selected="active"
        :title="$t('authentication-app.tab.corporate-account.short')"
        icon="briefcase"
        wide
        data-testid="corporate-account"
        @click.native="onSelect"
      />
    </template>
  </Tabs>
</template>

<script>
import Tabs from "@paybis/frontend-common-lib/src/components/v2/tabs.vue";
import Tab from "@paybis/frontend-common-lib/src/components/v2/tab.vue";
import { UserType } from "@/types";
import UrlHelper from "@/helpers/UrlHelper";
import { mapGetters } from "vuex";

export default {
  components: {
    Tabs,
    Tab,
  },
  props: {
    value: {
      type: String,
      default: UserType.PRIVATE,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabs: {
        personalAccountTab: UserType.PRIVATE,
        corporateAccountTab: UserType.CORPORATE,
      },
    };
  },
  computed: {
    ...mapGetters(['language']),
    tabList() {
      return Object.values(this.tabs);
    },
    valueLocal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onTabSelect(value) {
      if(this.isDisabled) return;
      this.valueLocal = value;

      const link = document.querySelector(".nav-logo__link");
      if(!link) return;

      link.setAttribute('href', value === 'corporate' ? UrlHelper.toPaybisFrontUrl('corporate/', this.language) : UrlHelper.toPaybisFrontUrl('', this.language));
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .tabs__head {
  padding: 0;
  margin-bottom: rem(38);
}

::v-deep .tabs__toggle {
  color: $black-56;
}

::v-deep .tabs__toggle.is-selected {
  color: $black;
}

::v-deep .tabs__toggle.is-disabled {
  color: $grey-30;
  cursor: auto;
}
</style>
